import React from 'react';

import PropTypes from 'prop-types';

var cardDrawer = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  content: PropTypes.any.isRequired
});

var cardDrawers = PropTypes.arrayOf(cardDrawer);

export default { cardDrawer: cardDrawer, cardDrawers: cardDrawers };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-card/es/CardPropTypes.js
// module id = 274
// module chunks = 0